import NumberFormatter from './number-formatter';
var CurrencyFormatter = /** @class */ (function () {
    function CurrencyFormatter() {
    }
    CurrencyFormatter.format = function (value, currencyFormat) {
        var _a, _b;
        if (currencyFormat === void 0) { currencyFormat = null; }
        if (!currencyFormat) {
            currencyFormat = window.App.locale.currencyFormat;
        }
        var regex = /\{.*?\}/g;
        var matches = currencyFormat.match(regex);
        if (!matches) {
            return null;
        }
        var valueFormat = matches[0].substr(1, matches[0].length - 1);
        var valueFormatParts = valueFormat.split('|');
        var decimals = valueFormatParts[1] ? parseInt(valueFormatParts[1]) : 0;
        var thousandSeparator = (_a = valueFormatParts[2]) !== null && _a !== void 0 ? _a : ' ';
        var decimalSeparator = (_b = valueFormatParts[3]) !== null && _b !== void 0 ? _b : ',';
        var formattedValue = NumberFormatter.format(value, decimals, thousandSeparator, decimalSeparator);
        return currencyFormat.replace(matches[0], formattedValue.toString());
    };
    return CurrencyFormatter;
}());
export default CurrencyFormatter;
